
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2216"}},[_c('path',{attrs:{"data-name":"Rectangle 2937","fill":"none","d":"M0 0h124.999v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1346","d":"M124.999 75.414L80.878 31.293A23.927 23.927 0 0063.671 24H38.337a24.027 24.027 0 00-24 24v11.875h-3.336a9.99 9.99 0 00-6.809 17.31L46.083 120h78.918z","fill":"#ec4618"}}),_c('g',{attrs:{"data-name":"Group 2215","fill":"#f9a36c"}},[_c('path',{attrs:{"data-name":"Path 1347","d":"M90.999 59.875h-3.328V48a24.026 24.026 0 00-24-24H38.337a24.027 24.027 0 00-24 24v11.875h-3.336a10 10 0 000 20h4.313A11.839 11.839 0 0014.541 84a12 12 0 0024 0 11.84 11.84 0 00-.774-4.125h28.914A11.862 11.862 0 0065.908 84a12 12 0 0024 0 11.84 11.84 0 00-.774-4.125h1.867a10 10 0 000-20zM22.337 48a16.014 16.014 0 0116-16h25.336a16.018 16.018 0 0116 16v11.875H22.337z"}}),_c('path',{attrs:{"data-name":"Path 1348","d":"M62.499 40.985H47.367a6.543 6.543 0 00-6.008-4.133 6.653 6.653 0 00-6.524 6.746v4.633a6.653 6.653 0 006.524 6.746 6.508 6.508 0 005.875-3.875h15.265a5.059 5.059 0 100-10.117z"}})])])])
          )
        }
      }
    